"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportNavigationTranslations = {
    "en": {
        historicalReport: "Historical Report",
        activeReport: "Active Report (today)",
        selectAgent: "Select agent",
    },
    "de": {
        selectAgent: "Mitarbeiter auswählen",
        historicalReport: "Historischer Bericht",
        activeReport: "Aktiver Bericht (heute)",
    },
    "nl": {
        selectAgent: "Agent selecteren",
        historicalReport: "Historisch rapport",
        activeReport: "Actief rapport (vandaag)",
    },
    "it": {
        selectAgent: "Seleziona agente",
        historicalReport: "Statistiche storico",
        activeReport: "Statistiche correnti (oggi)",
    },
    "fr": {
        selectAgent: "Sélectionner l'agent",
        historicalReport: "Rapport historique",
        activeReport: "Rapport actif (aujourd'hui)",
    },
    "es": {
        selectAgent: "Seleccione agente",
        historicalReport: "Informe histórico",
        activeReport: "Informe activo (hoy)",
    },
    "ja": {
        selectAgent: "エージェントの選択",
        historicalReport: "履歴レポート",
        activeReport: "アクティブレポート（本日）",
    },
    "en-GB": {
        selectAgent: "Select agent",
        historicalReport: "Historical Report",
        activeReport: "Active Report (today)",
    },
    "ru": {
        historicalReport: "Исторический Отчет",
        activeReport: "Активный Отчет (сегодня)",
        selectAgent: "Выбрать агента",
    },
};
